import React from 'react';

import { Typography } from 'components/shared/Typography';

import { formatDate } from 'helpers/formatDate';

import { StudentInfo } from '../StudentInfo';

import styles from './SurveyItem.module.scss';
import { prepareSurveyAnswers } from './SurveyItem.helpers';

const SurveyItem = ({ survey, locale }: { survey: any; locale: any }) => {
  const preparedAnswers = prepareSurveyAnswers(survey);

  return (
    <>
      <div className={styles.header}>
        <StudentInfo data={survey} />
        <div className={styles.emailFromContainer}>
          <Typography variant="body3" className={styles.emailFrom}>
            Type
          </Typography>
          <Typography variant="body3">{survey.type}</Typography>
        </div>
        <Typography variant="body3" className={styles.date}>
          {survey.createdAt &&
            formatDate(survey.createdAt, 'dd MMM, yyyy HH:MM', locale)}
        </Typography>
      </div>
      <div className={styles.content}>
        {preparedAnswers.map(({ question, answer }, index) => (
          <div className={styles.answer} key={`${question}-${index}`}>
            <Typography
              className={styles.answerTitle}
              variant="body3"
              mode="compact"
            >
              {question}
            </Typography>
            <Typography
              className={styles.answerText}
              variant="body3"
              weight="medium"
              mode="compact"
            >
              {answer}
            </Typography>
          </div>
        ))}
      </div>
    </>
  );
};

export default React.memo(SurveyItem) as any;
